var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1994,
    cy: 17.5463,
    r: 16.6994,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8929 7.91601L16.4226 5.38628C16.7982 5.01069 17.4002 4.98944 17.8013 5.33756C18.1363 5.62837 18.4026 5.87261 18.6002 6.07027C24.922 12.392 24.922 22.6414 18.6002 28.9631C18.4026 29.1608 18.1362 29.405 17.8012 29.6958C17.4002 30.0439 16.7982 30.0227 16.4227 29.6471L13.8928 27.1173C13.7092 26.9337 13.6945 26.6408 13.8587 26.4397C14.0062 26.2591 14.1225 26.112 14.2076 25.9984C15.0736 24.8431 15.7399 23.5855 16.2067 22.2729C16.2817 22.0622 16.4969 21.9355 16.7175 21.9723L19.3645 22.4134C20.6202 19.2776 20.6202 15.7558 19.3645 12.62L16.7222 13.0605C16.4989 13.0976 16.2811 12.9694 16.2052 12.7563C15.7381 11.444 15.0715 10.1869 14.2054 9.03203C14.1208 8.91914 14.0052 8.77306 13.8588 8.59371C13.6945 8.39254 13.7093 8.09965 13.8929 7.91601Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2815,
    height: 24.2815,
    fill: "white",
    transform: "translate(17.1694 34.6863) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhone);
export default __webpack_public_path__ + "static/media/i-phone.144744c602cf30d739bb3f0363912399.svg";
export { ForwardRef as ReactComponent };